// https://confluence-onera.atlassian.net/wiki/spaces/OA/pages/166920313/Endpoint+mapping

const environment = (import.meta as any).env;

export const requestUrl = {
  events: environment.VITE_EVENTS_API_URL,
  reports: environment.VITE_REPORTS_API_URL,
  signals: environment.VITE_SIGNALS_API_URL
};
